import { ContactDetailType } from '@mymsa/common'

export const contactDetailTypeMap = {
  [ContactDetailType.PHONE]: 'Phone',
  [ContactDetailType.MOBILE]: 'Mobile',
  [ContactDetailType.FAX]: 'Fax',
  [ContactDetailType.EMAIL]: 'Email',
  [ContactDetailType.WEBSITE]: 'Website'
}

export const contactDetailTypeOptions = Object.entries(contactDetailTypeMap).map(([value, text]) => ({ value, text }))
